/**
 * Calculate override value based on original value and override percentage
 */
export const calculateOverride = (
	original: number,
	occFcstOverride: number,
) => {
	const adjustmentPercent = occFcstOverride / 100;
	const adjustmentAmount = original * adjustmentPercent;
	return adjustmentAmount < 0
		? Math.floor(original + adjustmentAmount)
		: Math.ceil(original + adjustmentAmount);
};
